import _ from 'lodash';

const RackspacePermissionsStatus = ({ result }) => {
  const selectedPermissions = _.keys(_.pickBy(result.roles));
  const setSelectedPermissionsStatus = (selectedPermissions.length) ? selectedPermissions.join(' | ') : 'None';

  return (
    <div className="stepper__step-link">
      <strong>Granted Roles</strong>
      <br />
      <span className="stepper__permission-view">{ setSelectedPermissionsStatus }</span>
    </div>
  );
};

export default RackspacePermissionsStatus;
